import api from '../api';
import { patchStoredUser } from './authSession';
import { fetchFeatureFlags } from './featureFlags';

/** Atualiza plano, master e feature flags a partir da API (evita menu inconsistente). */
export async function refreshSessionContext() {
    await Promise.allSettled([
        api.get('/auth/me')
            .then((response) => {
                const user = response?.data?.data;
                if (!user || typeof user !== 'object') {
                    return;
                }
                const patch = {};
                if (typeof user.is_master === 'boolean') {
                    patch.is_master = user.is_master;
                }
                if (Object.keys(patch).length > 0) {
                    patchStoredUser(patch);
                }
            }),
        api.get('me/account')
            .then((response) => {
                const account = response?.data?.data;
                const planName = account?.plan?.name;
                const patch = {};
                if (planName) {
                    patch.plan_name = planName;
                }
                if (typeof account?.plan_migration_pending === 'boolean') {
                    patch.plan_migration_pending = account.plan_migration_pending;
                }
                if (account?.pending_plan?.name) {
                    patch.pending_plan_name = account.pending_plan.name;
                } else if (account?.plan_migration_pending === false) {
                    patch.pending_plan_name = null;
                }
                if (account?.pending_downgrade_plan?.name) {
                    patch.pending_downgrade_plan_name = account.pending_downgrade_plan.name;
                } else if (account?.plan_downgrade_pending === false) {
                    patch.pending_downgrade_plan_name = null;
                }
                if (Object.keys(patch).length > 0) {
                    patchStoredUser(patch);
                }
            }),
        fetchFeatureFlags(),
    ]);
}
